import dotProp from 'dot-prop-immutable';
import * as _ from 'lodash';
import {
  ADD_IMAGE_TO_TEXTURE,
  GET_IMAGES,
  CREATE_TEXTURE,
  REMOVE_TEXTURE,
  SET_ZOOM_SCALE,
  ROTATE_IMAGE,
  RESET_TRANSFORMATIONS,
  REMOVE_TEXTURE_IMAGE,
  MOVE_IMAGE,
  FIT_IMAGE,
  CHANGE_TEXTURE_ORDER,
  FILL_IMAGE_SIZE,
  ADD_IMAGE_OBJECT,
  DPI_RESOLUTION,
  REMOVE_DPI_OVERLAY,
  ADD_DROPPED_IMAGE_TO_TEXTURE,
  REMOVE_IMAGE_FROM_TEXTURE,
  REORDER_PLACEHOLDERS,
  TOGGLE_DPI_OVERLAYS,
  LOAD_PLACEHOLDERS_BY_BOOK_ID,
  CHANGE_FILL_IMAGE_SIZE,
} from './../../action-types/entities/placeholders';
import { generateId, orientation } from '../../helpers/index';

export const STATE_KEY = 'placeholders';

export const placeholders = (state = {
  byId: {},
  allIds: [],
}, action) => {
  switch (action.type) {
    case GET_IMAGES: {
      // TODO refactor
      break;
    }
    case LOAD_PLACEHOLDERS_BY_BOOK_ID: {
      return action.bookState;
    }
    case ADD_IMAGE_TO_TEXTURE: {
      const { placeholdersId, imageId } = action;
      return {
        byId: dotProp.set(state.byId, `${placeholdersId}.image`, imageId),
        allIds: state.allIds,
      };
    }
    case REMOVE_TEXTURE: {
      const item = action.placeholdersId;
      return {
        byId: dotProp.delete(state.byId, item),
        allIds: dotProp.delete(state.allIds, state.allIds.indexOf(item)),
      };
    }

    case CREATE_TEXTURE: {
      const { texture } = action;
      texture.id = generateId(state.allIds);
      return {
        byId: {
          ...state.byId,
          [texture.id]: texture,
        },
        allIds: [...state.allIds, texture.id],
      };
    }


    case SET_ZOOM_SCALE: {
      const { placeholderId, zoomIn } = action;
      const zoomScale = 0.1;
      const minZoom = 1.1;

      const scaleX = zoomIn
        ? state.byId[placeholderId].transformations.scaleX + zoomScale
        : state.byId[placeholderId].transformations.scaleX - zoomScale;

      const fillWidthSize = state.byId[placeholderId].transformations.fillSizes.originalWidth;
      const fillHeightSize = state.byId[placeholderId].transformations.fillSizes.originalHeight;

      const fillWidthOriginalSize = state.byId[placeholderId].transformations.fillSizes.originalWidth;
      const fillHeightOriginalSize = state.byId[placeholderId].transformations.fillSizes.originalHeight;

      const zoomSize = {
        width: scaleX >= minZoom ? fillWidthSize * scaleX : fillWidthSize,
        height: scaleX >= minZoom ? fillHeightSize * scaleX : fillHeightSize,
      };

      const moveX = -1 * Math.abs(((zoomSize.width - state.byId[placeholderId].width) / 2));
      const moveY = -1 * Math.abs(((zoomSize.height - state.byId[placeholderId].height) / 2));
      const { width, height } = state.byId[placeholderId].imageObject;

      const { rotate } = state.byId[placeholderId].transformations;

      const ratio = {
        minimum: rotate === 90 || rotate === 270 ? fillHeightOriginalSize / height : fillWidthOriginalSize / width,
        maximum: rotate === 90 || rotate === 270 ? zoomSize.height / height : zoomSize.width / width,
      };

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            transformations: {
              ...state.byId[placeholderId].transformations,
              moveX,
              moveY,
              scaleX: scaleX >= minZoom ? scaleX : 1,
              scaleY: scaleX >= minZoom ? scaleX : 1,
              fillSizes: {
                ...state.byId[placeholderId].transformations.fillSizes,
                width: scaleX >= minZoom ? zoomSize.width : fillWidthOriginalSize,
                height: scaleX >= minZoom ? zoomSize.height : fillHeightOriginalSize,
              },
            },
            imageRatio: scaleX >= minZoom ? ratio.maximum : ratio.minimum,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case ROTATE_IMAGE: {
      const { placeholderId } = action;
      const degree = state.byId[placeholderId].transformations.rotate;

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            transformations: {
              ...state.byId[placeholderId].transformations,
              rotate: degree >= 270 ? 0 : degree + 90,
              moveX: 0,
              moveY: 0,
              scaleX: 1,
              scaleY: 1,
              isFit: false,
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case MOVE_IMAGE: {
      const {
        placeholderId,
        moveX,
        moveY,
      } = action;


      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            transformations: {
              ...state.byId[placeholderId].transformations,
              moveX,
              moveY,
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case FIT_IMAGE: {
      const { placeholderId, isFit, fitSizes } = action;
      const {
        originalHeight,
        originalWidth,
        originalTop,
        originalLeft,
      } = state.byId[placeholderId];


      const fillWidthOriginalSize = state.byId[placeholderId].transformations.fillSizes.originalWidth;
      const fillHeightOriginalSize = state.byId[placeholderId].transformations.fillSizes.originalHeight;
      const imageOriginalWidth = state.byId[placeholderId].imageObject.width;

      const imageRatio = fillWidthOriginalSize / imageOriginalWidth;
      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            height: isFit ? fitSizes.height : originalHeight,
            width: isFit ? fitSizes.width : originalWidth,
            top: isFit ? (((originalHeight / 2) - (fitSizes.height / 2)) + originalTop) : originalTop,
            left: isFit ? (((originalWidth / 2) - (fitSizes.width / 2)) + originalLeft) : originalLeft,
            transformations: {
              ...state.byId[placeholderId].transformations,
              isFit,
              scaleX: 1,
              scaleY: 1,
              fitSizes: {
                width: fitSizes.width,
                height: fitSizes.height,
              },
              moveX: 0,
              moveY: 0,
              fillSizes: {
                width: fillWidthOriginalSize,
                height: fillHeightOriginalSize,
                originalWidth: fillWidthOriginalSize,
                originalHeight: fillHeightOriginalSize,
              },
            },
            imageRatio,
          },

        },
        allIds: [...state.allIds],
      };
    }

    case REMOVE_TEXTURE_IMAGE: {
      const { placeholderId } = action;
      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            transformations: {
              scaleX: 1,
              scaleY: 1,
              rotate: 0,
              moveX: 0,
              moveY: 0,
              isFit: false,
              fillSizes: {},
            },
            isChanged: true,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case RESET_TRANSFORMATIONS: {
      const {
        placeholderId,
        center,
      } = action;

      const {
        moveY,
        moveX,
      } = center;

      const fillWidthOriginalSize = state.byId[placeholderId].transformations.fillSizes.originalWidth;
      const fillHeightOriginalSize = state.byId[placeholderId].transformations.fillSizes.originalHeight;
      const imageOriginalWidth = state.byId[placeholderId].imageObject.width;
      const imageOriginalHeight = state.byId[placeholderId].imageObject.height;
      const { rotate } = state.byId[placeholderId].transformations;

      const imageRatio = rotate === 90 || rotate === 270 ? fillHeightOriginalSize / imageOriginalHeight : fillWidthOriginalSize / imageOriginalWidth;
      return Object.assign({}, state, {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            imageRatio,
            transformations: {
              scaleX: 1,
              scaleY: 1,
              rotate: 0,
              moveX,
              moveY,
              isFit: false,
              fillSizes: {
                ...state.byId[placeholderId].transformations.fillSizes,
                width: fillWidthOriginalSize,
                originalWidth: fillWidthOriginalSize,
                originalHeight: fillHeightOriginalSize,
                height: fillHeightOriginalSize,
              },
            },
          },
        },
      });
    }

    case FILL_IMAGE_SIZE: {
      const { sizes, placeholderId } = action;
      if (state.byId[placeholderId] !== undefined && state.byId[placeholderId].transformations !== undefined) {
        const { imageObject } = state.byId[placeholderId];

        return {
          byId: {
            ...state.byId,
            [placeholderId]: {
              ...state.byId[placeholderId],
              imageRatio: sizes.width / imageObject.width,
              transformations: {
                ...state.byId[placeholderId].transformations,
                moveX: sizes.x,
                moveY: sizes.y,
                fillSizes: {
                  width: sizes.width,
                  height: sizes.height,
                  originalWidth: sizes.width,
                  originalHeight: sizes.height,
                },
              },
            },
          },
          allIds: [...state.allIds],
        };
      }
      return;
    }

    case CHANGE_FILL_IMAGE_SIZE: {
      const { sizes, placeholderId } = action;

      const fillWidth = sizes.width;
      const fillHeight = sizes.height;
      const { imageObject, transformations } = state.byId[placeholderId];
      const { rotate } = transformations;

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            transformations: {
              ...state.byId[placeholderId].transformations,
              moveX: 0,
              moveY: 0,
              fillSizes: {
                width: fillWidth,
                height: fillHeight,
                originalWidth: fillWidth,
                originalHeight: fillHeight,
              },
            },
            imageRatio: rotate === 90 || rotate === 270 ? fillHeight / imageObject.width : fillWidth / imageObject.width,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case CHANGE_TEXTURE_ORDER: {
      const {
        oldplaceholderId,
        oldTextureImage,
        newplaceholderId,
        newTextureImage,
        toFillSizes,
        fromFillSizes,
        toImageRatio,
        fromImageRatio,
        fromCenter,
        toCenter,
      } = action;


      return {
        byId: {
          ...state.byId,
          [oldplaceholderId]: {
            ...state.byId[oldplaceholderId],
            image: newTextureImage,
            transformations: {
              ...state.byId[oldplaceholderId].transformations,
              fillSizes: {
                width: fromFillSizes.width,
                height: fromFillSizes.height,
                originalHeight: fromFillSizes.height,
                originalWidth: fromFillSizes.width,
              },
              scaleX: 1,
              scaleY: 1,
              rotate: 0,
              // moveX: toCenter.moveX,
              // moveY: toCenter.moveY,
              moveX: fromCenter.moveX,
              moveY: fromCenter.moveY,
              isFit: false,
            },
            imageObject: { ...state.byId[newplaceholderId].imageObject },
            imageRatio: fromImageRatio,
          },
          [newplaceholderId]: {
            ...state.byId[newplaceholderId],
            image: oldTextureImage,
            transformations: {
              ...state.byId[newplaceholderId].transformations,
              scaleX: 1,
              scaleY: 1,
              rotate: 0,
              moveX: toCenter.moveX,
              moveY: toCenter.moveY,
              isFit: false,
              fillSizes: {
                width: toFillSizes.width,
                height: toFillSizes.height,
                originalHeight: toFillSizes.height,
                originalWidth: toFillSizes.width,

              },
            },
            imageObject: { ...state.byId[oldplaceholderId].imageObject },
            imageRatio: toImageRatio,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case ADD_IMAGE_OBJECT: {
      const { placeholderId, imageObject } = action;

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            transformations: {
              scaleX: 1,
              scaleY: 1,
              rotate: 0,
              moveX: 0,
              moveY: 0,
              isFit: false,
              fillSizes: {
                ...state.byId[placeholderId].transformations.fillSizes,
              },
            },
            imageObject,
            isChanged: null,
          },
        },
        allIds: [...state.allIds],
      };
    }

    case DPI_RESOLUTION: {
      const { placeholderId, isSmall } = action;

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            DPI: {
              ...state.byId[placeholderId].DPI,
              isSmall,
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case REMOVE_DPI_OVERLAY: {
      const { placeholderId, isClicked } = action;

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            DPI: {
              ...state.byId[placeholderId].DPI,
              isClicked,
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case ADD_DROPPED_IMAGE_TO_TEXTURE: {
      const {
        placeholderId, imgObject, fillSize,
      } = action;

      const textProperties = {};
      const textState = state.byId;
      for (const texture in textState) {
        if (texture in textState) {
          const TextProp = Object.assign({}, state.byId[texture]);
          textProperties[texture] = TextProp;

          if (textProperties[texture].id === placeholderId) {
            textProperties[texture].image = placeholderId;
            textProperties[texture].imageRatio = fillSize.width / imgObject.width;
            textProperties[texture].isChanged = null;
            textProperties[texture].transformations.fillSizes = {
              width: fillSize.width,
              height: fillSize.height,
              originalWidth: fillSize.width,
              originalHeight: fillSize.height,
            };
            textProperties[texture].imageObject = imgObject;
          }
        }
      }

      return Object.assign({}, state, { byId: textProperties });
    }


    case REMOVE_IMAGE_FROM_TEXTURE: {
      const { placeholderId } = action;

      return {
        byId: {
          ...state.byId,
          [placeholderId]: {
            ...state.byId[placeholderId],
            image: 0,
            imageObject: {},
            transformations: {
              ...state.byId[placeholderId].transformations,
              rotate: 0,
              scaleX: 1,
              scaleY: 1,
            },
            DPI: {
              isSmall: false,
              isClicked: false,
            },
          },
        },
        allIds: [...state.allIds],
      };
    }

    case TOGGLE_DPI_OVERLAYS: {
      const { status } = action;

      const newById = {};
      const placeholders = state.byId;

      for (const DPI in placeholders) {
        if (DPI in placeholders) {
          const placeholder = Object.assign({}, placeholders[DPI]);
          placeholder.DPI.isSmall = status;
          placeholder.DPI.isClicked = status;
          newById[DPI] = placeholder;
        }
      }
      return Object.assign({}, state, { byId: newById });
    }

    case REORDER_PLACEHOLDERS: {
      const { currentPage, allImageById } = action;
      const copiedCurrentPage = Object.assign({}, currentPage);
      const { droppedImages, placeholders } = copiedCurrentPage;
      const copiedState = Object.assign({}, state);
      const tempImageIdArray = [];

      Object.keys(placeholders).forEach((element) => {
        let imageIds = 0;
        const { placeholderId } = placeholders[element];

        imageIds = placeholders[element].imageId;
        copiedState.byId[placeholderId].imageObject = allImageById[imageIds];

        const imgId = Object.keys(droppedImages).find((imageId) => {
          if ((_.includes(tempImageIdArray, imageId) === false) && droppedImages[imageId].orientation === orientation(copiedState.byId[placeholderId].width, copiedState.byId[placeholderId].height)) {
            tempImageIdArray.push(imageId);
            return imageId;
          }
        });
        copiedState.byId[placeholderId].image = imgId;
      });

      return copiedState;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/entities/placeholders.js